import { isRepaymentSettled } from "../utils/repaymentStatus";
import React, { useEffect, useMemo, useState } from "react";
import KPIChartCard from "./KPIChartCard";

const money0 = (n, compact = false) => {
  if (!Number.isFinite(+n)) return "—";
  const value = +n;
  if (!compact) {
    return value.toLocaleString("en-US", { style: "currency", currency: "SGD" });
  }
  return new Intl.NumberFormat("en-SG", {
    style: "currency",
    currency: "SGD",
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 1,
  }).format(value);
};

export default function InterestPaidBorrower({ alltheFreakingLoanData }) {
  const getIsMobile = () =>
    typeof window !== "undefined" ? window.innerWidth <= 1200 : false;
  const [isMobile, setIsMobile] = useState(getIsMobile());

  useEffect(() => {
    const handleResize = () => setIsMobile(getIsMobile());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const m = useMemo(() => {
    const loans = Array.isArray(alltheFreakingLoanData)
      ? alltheFreakingLoanData
      : [];

    let paid = 0;
    let total = 0;
    let months = 0;

    for (const loan of loans) {
      for (const r of loan?.remaining || []) {
        total += +r.repay_interest || 0;
        months += 1;
        if (isRepaymentSettled(r)) paid += +r.repay_interest || 0;
      }
    }

    const pct = total > 0 ? Math.round((paid / total) * 100) : 0;
    const avg = months > 0 ? total / months : null;

    return { paid, total, pct, avg, isEmpty: total <= 0 };
  }, [alltheFreakingLoanData]);

  return (
    <KPIChartCard
      title="Interest Paid"
      pill="Includes assumed paid"
      value={money0(m.paid, isMobile)}
      subtitle={m.isEmpty || isMobile ? "" : `Out of ${money0(m.total)}`}
      footer={m.isEmpty || isMobile ? "" : `Avg ${money0(m.avg)} / month`}
      isEmpty={m.isEmpty}
      emptyTitle="No interest data"
      emptySub="Once repayments start, interest progress will show here."
    >
      <div style={{ width: "100%" }}>
        <div
          style={{
            height: isMobile ? 8 : 12,
            borderRadius: 999,
            background: "var(--br-soft, rgba(148,163,184,0.25))",
            overflow: "hidden",
            border: "1px solid var(--br-border, rgba(148,163,184,0.18))",
          }}
        >
          <div
            style={{
              width: `${Math.max(2, m.pct)}%`,
              height: "100%",
              borderRadius: 999,
              background: "var(--br-primary, #7057f6)",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 10,
            fontFamily: "Manrope, sans-serif",
            fontWeight: 800,
            fontSize: isMobile ? 11 : 12,
            color: "var(--br-muted, rgba(15,23,42,0.45))",
          }}
        >
          <div>{m.pct}% complete</div>
          {!isMobile ? (
            <div>
              {m.total > 0 ? money0(m.total - m.paid) : "—"} remaining
            </div>
          ) : null}
        </div>
      </div>
    </KPIChartCard>
  );
}
